import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { ApplicationPracticalExperienceDto } from "../../../types/applicationTypes";
import WorkExperience from "./WorkExperience";
import ProfileDataCard from "./ProfileDataCard";

interface HiwiStudentJobsProps {
  hiwiStudentJobs: ApplicationPracticalExperienceDto[];
}

/**
 * This component displays the Hiwi-/Werkstudententätigkeit/Nebenjob of an applicant.
 * @param hiwiStudentJobs The Hiwi-/Werkstudent
 * @returns The Hiwi-/Werkstudententätigkeit/Nebenjob of an applicant.
 */
const HiwiStudentJobs = ({ hiwiStudentJobs }: HiwiStudentJobsProps) => {
  return (
    <ProfileDataCard title="Hiwi-/Werkstudententätigkeit/Nebenjob">
      {hiwiStudentJobs.length === 0 ? (
        <Typography>Keine Angaben</Typography>
      ) : (
        hiwiStudentJobs.map((hiwiStudentJob, index) => {
          // if it is the last item, don't add margin and divider
          if (index === hiwiStudentJobs.length - 1) {
            return (
              <WorkExperience
                key={index}
                jobTitle={hiwiStudentJob.activity}
                company={hiwiStudentJob.company}
                location={hiwiStudentJob.location}
                start={hiwiStudentJob.start ? hiwiStudentJob.start : null}
                end={hiwiStudentJob.end ? hiwiStudentJob.end : null}
              />
            );
          }
          return (
            <Box key={index} mb={2}>
              <WorkExperience
                key={index}
                jobTitle={hiwiStudentJob.activity}
                company={hiwiStudentJob.company}
                location={hiwiStudentJob.location}
                start={hiwiStudentJob.start ? hiwiStudentJob.start : null}
                end={hiwiStudentJob.end ? hiwiStudentJob.end : null}
              />
              <Divider sx={{ mt: 2 }} />
            </Box>
          );
        })
      )}
    </ProfileDataCard>
  );
};

export default HiwiStudentJobs;
